// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import ConnectViewer from 'app/common/react/components/common/ConnectViewer/ConnectViewer';
import getBoardOrder from 'app/common/react/components/profile/ProfileBoards/utils/getBoardOrder';
import ProfileBoards from 'app/common/react/components/profile/ProfileBoards/ProfileBoards';
import type { BoardSortOptionsType } from 'app/packages/pinterest-flow-types/user';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import withResource, { type Resource } from 'app/common/lib/react/withResource';
import {
  withRequestContext,
  type RequestContextType,
} from 'app/common/react/components/RequestContext';

type Props = {|
  requestContext: RequestContextType,
  updatedBoardOrder?: BoardSortOptionsType,
  userMetadataResource: Resource<{
    most_recent_board_sort_order: ?BoardSortOptionsType,
  }>,
  userResource: Resource<{
    blocked_by_me: boolean,
    first_name: string,
    has_custom_board_sorting_order: boolean,
    secret_board_count: number,
    username: string,
  }>,
|};

function ProfileBoardsPage({
  requestContext,
  userResource: { data: user },
  userMetadataResource: { data: userMetadata },
  updatedBoardOrder,
}: Props) {
  if (!user || !userMetadata) {
    return null;
  }
  const { most_recent_board_sort_order: mostRecentBoardSortOrder } = userMetadata;
  const {
    username,
    has_custom_board_sorting_order: hasCustomOrder,
    blocked_by_me: isUserBlocked,
  } = user;
  return (
    <ConnectViewer>
      {(viewer) => {
        const isOwnProfile = viewer.username === username;
        const boardOrder = getBoardOrder({
          hasCustomOrder,
          isOwnProfile,
          mostRecentBoardSortOrder: mostRecentBoardSortOrder || undefined,
          updatedBoardOrder,
        });

        return (
          <ProfileBoards
            boardOrder={boardOrder}
            isOwnProfile={isOwnProfile}
            isUserBlocked={isUserBlocked}
            mixPublicSecret={!viewer.isPartner && isOwnProfile}
            user={user}
            username={user.username}
          />
        );
      }}
    </ConnectViewer>
  );
}

export default compose(
  withRequestContext,
  connect(
    createStructuredSelector({
      updatedBoardOrder: (state) => state.ui.views && state.ui.views.updatedBoardOrder,
    }),
  ),
  withResource({
    name: 'UserResource',
    key: 'userResource',
    options: ({ params }) => ({
      field_set_key: 'profile',
      username: params.username,
    }),
  }),
  withResource(
    {
      name: 'UserMetadataResource',
      key: 'userMetadataResource',
      options: ({ params }) => ({
        user: {
          id: params.username,
        },
      }),
    },
    { acceptPrefetch: true },
  ),
)(ProfileBoardsPage);
